import { type ApiOrder } from '@Model';
import { FloatingCard, type IGuiBinder, type Index } from '@synqo/frontend-component-library';
import { memo } from 'react';
import { useRemarks } from '../../useRemarks';

const remarkTypes: [Index<ApiOrder>, string][] = [
    ['remarks', 'Auftrag'],
    ['scale_remarks', 'Waage'],
    ['invoice_remarks', 'Rechnung'],
];

interface IProps {
    binder: IGuiBinder<ApiOrder>;
    order: ApiOrder;
    canEdit: boolean;
}

// @ai-generated 2026-10-27T16:15:27+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export const OrderRemarksSection = memo(function OrderRemarksSection({ binder, order, canEdit }: IProps) {
    const { hasRemarks, addRemarkMenu, remarkInputs } = useRemarks({ remarkTypes, data: order, binder, canEdit });

    if (!canEdit && !hasRemarks) {
        return undefined;
    }

    return (
        <FloatingCard title={'Bemerkung'} collapsible={hasRemarks} additionalHeaderItems={addRemarkMenu}>
            {remarkInputs}
        </FloatingCard>
    );
});
